import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IndueCardStatus, useAccountByIdOrNumberQuery, } from "generated/generated-models";
import { useParams, useNavigate } from "react-router-dom";
import { Card } from "@mui/material";
import { clientConfigFn } from "clientConfig";
import MoneySigned from "app/components/MoneySigned";
import SanitisedImage from "app/components/SanitisedImage";
import dayjs from "dayjs";
import { GetAssetUri } from "core/util/pathsHelper";
const statusToText = (status) => {
    switch (status) {
        case IndueCardStatus.Active:
            return "Active";
        case IndueCardStatus.Activeoff:
            return "On Hold";
        case IndueCardStatus.Cardcreated:
            return "Created";
        case IndueCardStatus.Closed:
            return "Closed";
        case IndueCardStatus.Lost:
            return "Lost";
        case IndueCardStatus.Ordered:
            return "Ordered";
        case IndueCardStatus.Other:
            return "Other";
        case IndueCardStatus.Restricted:
            return "Restricted";
        case IndueCardStatus.Stolen:
            return "Stolen";
        case IndueCardStatus.Damaged:
            return "Damaged";
    }
    return true;
};
const CardTableRow = ({ card, account, }) => {
    const navigate = useNavigate();
    const clientConfig = clientConfigFn();
    const { data } = useAccountByIdOrNumberQuery({
        variables: { idOrNumber: account },
    });
    const handleClick = () => {
        navigate(`/account/index/${account}/induecards/${card.Id}`);
    };
    const lastFourDigits = card.CardNumber?.substring(card.CardNumber?.length - 4) ?? "";
    const maskedCard = "•••• •••• •••• " + lastFourDigits;
    const { cardid } = useParams();
    let cardClassName = "cardElement";
    let cardStyles = {
        paperContainer: {
            backgroundImage: `url(${clientConfig.bankCardInActiveUri
                ? GetAssetUri(clientConfig.bankCardInActiveUri)
                : ""})`,
        },
    };
    if (card.Id === cardid) {
        cardClassName = "cardElementSelected";
        cardStyles = {
            paperContainer: {
                backgroundImage: `url(${clientConfig.bankCardActiveUri
                    ? GetAssetUri(clientConfig.bankCardActiveUri)
                    : ""})`,
            },
        };
    }
    return (_jsxs(Card, { className: `cardItem ${cardClassName}`, onClick: handleClick, style: cardStyles.paperContainer, children: [_jsxs("div", { className: "cardHeader", children: [_jsx(SanitisedImage, { src: GetAssetUri(clientConfig.logoImageVariantUri), height: "22px" }), _jsx("p", { className: `cardStatus status-${card.Status}`, children: statusToText(card.Status) })] }), _jsxs("p", { className: "cardBalance", children: [_jsx("span", { className: "bal-title", children: "Balance" }), _jsx(MoneySigned, { amount: data?.accountByIdOrNumber?.CurrentBalance, direction: "total" })] }), _jsxs("div", { className: "cardDetails", children: [_jsx("p", { children: maskedCard }), _jsx("p", { children: dayjs(card.ExpiryDate).format("MM/YY") })] })] }, card.Id));
};
const CardTableBody = (account, cards) => {
    if (!cards || cards.length === 0) {
        return _jsx("p", { children: "There are no cards for this account" });
    }
    return cards.map((card) => (_jsx(CardTableRow, { card: card, account: account }, card.Id)));
};
const IndueCardListTable = ({ accountNumber, cards, }) => {
    return (_jsx("div", { className: "cardListContainer", children: CardTableBody(accountNumber, cards) }));
};
export default IndueCardListTable;
